import React from 'react';
import Agent3DPage from '@src/components/agent-3d-page/Agent3D';
import Head from 'next/head';
import { PREVIEW_IMAGES_CDN } from 'util/constants';
import type { GetStaticProps } from 'next';

export const Agent3D = () => {
  return (
    <>
      <Head>
        <title>Agent 3D - Ozone Metaverse Platform</title>
        <meta
          name='description'
          content='Build and launch lifelike AI avatars online. Easy customization, instant deployment, and zero coding - all in your browser.'
        />
        <meta
          property='og:title'
          content='Agent 3D - Ozone Metaverse Platform'
        />
        <meta
          property='og:description'
          content='Build and launch lifelike AI avatars online. Easy customization, instant deployment, and zero coding - all in your browser.'
        />
        <meta property='og:url' content='https://ozonemetaverse.io/agent3d' />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content={`${PREVIEW_IMAGES_CDN}/preview-agent-3d.jpg`}
        />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
        <meta
          name='twitter:title'
          content='Agent 3D - Ozone Metaverse Platform'
        />
        <meta
          name='twitter:description'
          content='Build and launch lifelike AI avatars online. Easy customization, instant deployment, and zero coding - all in your browser.'
        />
        <meta
          name='twitter:image'
          content={`${PREVIEW_IMAGES_CDN}/preview-agent-3d.jpg`}
        />
        <meta name='twitter:card' content='summary_large_image' />
      </Head>
      <style global>
        {`
          .content {
            background-image: none;
            overflow: hidden;
            min-height: auto;
          }
        `}
      </style>
      <Agent3DPage />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default Agent3D;
